import { Controller } from '@hotwired/stimulus';
import CountdownTimer from '../components/countdown_timer';

export default class extends Controller {
  static targets = ['countdown'];
  static values = {
    startDate: String,
    daysLimit: Number,
    enableCountdown: { type: Boolean, default: false },
  };

  connect() {
    if (this.shouldEnableCountdown()) {
      this.initializeCountdown();
    } else {
      this.show();
    }
  }

  disconnect() {
    this.countdown?.stop();
  }

  shouldEnableCountdown() {
    return this.enableCountdownValue &&
      this.hasStartDateValue &&
      this.hasDaysLimitValue;
  }

  initializeCountdown() {
    this.countdown = new CountdownTimer(
      this.startDateValue,
      this.daysLimitValue,
      {
        onUpdate: (formattedTime) => this.updateText(formattedTime),
        onExpire: () => this.hide(),
      }
    );
    this.countdown.start();
  }

  updateText(text) {
    this.show();
    this.countdownTargets.forEach(el => {
      el.textContent = text;
    });
  }

  show() {
    this.element.classList.remove('d-none');
  }

  hide() {
    this.element.classList.add('d-none');
  }
}
